export default {
  name: '新闻公告',
  children: [
    // { menuId: 1, name: '中心新闻', url: 'centerNews' },
    {
      menuId: 2,
      name: '通知公告',
      url: 'broadcast',
    },
  ],
}
